<ziro-collapsible-section-card
  [isSwitchHidden]="true"
  [title]="'tkey;admin.ldap.settings.title'"
  [isCollapsible]="false"
>
  <legend class="mt-0">{{ 'tkey;admin.ldap.settings.servers.title' | translate }}</legend>

  <div class="card bg-light mb-3">
    <div class="card-body" [innerHtml]="'tkey;admin.ldap.settings.servers.description' | escapeHtml"></div>
  </div>

  <ziro-admin-ldap-management-settings-ldap-server-url
    fieldId="urls"
    (removeServerInParent)="onRemoveServer($event)"
  ></ziro-admin-ldap-management-settings-ldap-server-url>

  <legend>{{ 'tkey;admin.ldap.settings.account.title' | translate }}</legend>

  <div class="card bg-light mb-3">
    <div class="card-body" [innerHtml]="'tkey;admin.ldap.settings.account.description' | escapeHtml"></div>
  </div>

  <ziro-text fieldId="username"></ziro-text>
  <ziro-text fieldId="password"></ziro-text>

  <legend>{{ 'tkey;admin.ldap.settings.general.title' | translate }}</legend>

  <div class="card bg-light mb-3">
    <div class="card-body" [innerHTML]="'tkey;admin.ldap.settings.general.description' | escapeHtml"></div>
  </div>

  <ziro-text fieldId="userBaseDn"></ziro-text>
  <ziro-text fieldId="userIdAttributeName"></ziro-text>
  <ziro-text fieldId="userObjectClass"></ziro-text>
  <ziro-text fieldId="groupBaseDn"></ziro-text>
  <ziro-text fieldId="groupAttributeName"></ziro-text>
  <ziro-text fieldId="groupObjectClass"></ziro-text>
  <ziro-text fieldId="connectTimeout"></ziro-text>
  <ziro-text fieldId="readTimeout"></ziro-text>
  <div [hidden]="isProxyServerEnabled()">
    <legend>{{ 'tkey;admin.ldap.settings.site.title' | translate }}</legend>

    <div class="card bg-light mb-3">
      <div class="card-body">
        <span [innerHTML]="'tkey;admin.ldap.settings.site.description.1' | escapeHtml"></span>
        <a class="strong" [attr.href]="window.location.origin + '/app2/#/admin/site-management'" target="_blank">
          {{ 'tkey;admin.site_management.title' | translate }}
        </a>
        <span [innerHTML]="'tkey;admin.ldap.settings.site.description.2' | escapeHtml"></span>
      </div>
    </div>

    <ziro-text fieldId="siteAttributeName"></ziro-text>
    <ziro-checkbox fieldId="writeToSiteEnabled"></ziro-checkbox>

    <legend>{{ 'tkey;admin.ldap.settings.dial_plan.title' | translate }}</legend>

    <div class="card bg-light mb-3">
      <div class="card-body">
        <span [innerHTML]="'tkey;admin.ldap.settings.dial_plan.description.1' | escapeHtml"></span>
        <strong>
          <a [routerLink]="'/admin/cisco/dial-plan-management'" target="_blank">
            {{ 'tkey;dialplanmanagement.title' | translate }}
          </a>
        </strong>
        <span [innerHTML]="'tkey;admin.ldap.settings.dial_plan.description.2' | escapeHtml"></span>
      </div>
    </div>

    <ziro-text fieldId="extensionAttributeName"></ziro-text>
    <ziro-text fieldId="e164NumberAttributeName"></ziro-text>

    <legend>{{ 'tkey;admin.ldap.settings.additional.title' | translate }}</legend>

    <div class="card bg-light mb-3">
      <div class="card-body" [innerHTML]="'tkey;admin.ldap.settings.additional.description' | escapeHtml"></div>
    </div>

    <ziro-text fieldId="photoAttributeName"></ziro-text>
    <ziro-multi-text fieldId="additionalAttributeNames"></ziro-multi-text>
  </div>
  <div class="d-flex justify-content-end">
    <ziro-submit-button
      [isPending]="isSubmitting"
      [isDisabled]="isSubmitting"
      [label]="'tkey;global.button.save.text'"
      [dataAutomation]="'save-ldap-settings'"
      [buttonStyle]="ButtonStyles.OUTLINE_PRIMARY"
      [icon]="ziroIcons.SAVE_SUCCESS"
      [iconPending]="ziroIcons.SAVING"
      [formSubmitSubject]="_validateAndSubmitSource"
    ></ziro-submit-button>
  </div>
</ziro-collapsible-section-card>
